import React from "react";
import "./Hardware.css";

export default function Hardware(): JSX.Element {
  return (
    <main className="hardware-page">
      <div className="hardware-hero">
        <h1>COMING SOON</h1>
      </div>
    </main>
  );
}
